import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "batch-un-maintain"
};
const _hoisted_2 = {
  class: "batch-un-maintain-table"
};
const _hoisted_3 = {
  class: "btn-group"
};
import { onMounted, ref, toRefs, computed, watch } from 'vue';
import { queryMaintain, updateMaintain } from '@/api/management/batchOperation';
import { ElMessage, ElMessageBox } from 'element-plus';
import { useUserDefaultSettingStore } from '@/store/user';
import { storeToRefs } from 'pinia';
export default /*@__PURE__*/_defineComponent({
  __name: 'batch-unmaintain-dialog',
  props: {
    visible: {
      type: Boolean
    },
    clusterIdList: {},
    zoneIdList: {},
    checkIdList: {}
  },
  emits: ["confirm", "update:visible"],
  setup(__props, {
    emit: __emit
  }) {
    const store = useUserDefaultSettingStore();
    const {
      userName,
      timeZone
    } = storeToRefs(store);
    const props = __props;
    const {
      visible,
      clusterIdList,
      zoneIdList,
      checkIdList
    } = toRefs(props);
    const tableData = ref([]);
    const initTable = async () => {
      const clusterIds = clusterIdList.value.join(',') || 0;
      const zoneIds = zoneIdList.value.join(',') || 0;
      const checkIds = checkIdList.value.join(',') || 0;
      const {
        commonMaintains
      } = await queryMaintain(clusterIds, zoneIds, checkIds);
      const maintainList = commonMaintains.filter(item => item.id !== 0);
      if (maintainList?.length < 1) {
        ElMessage({
          type: 'error',
          message: 'No Maintain data need UnMaintain'
        });
        return;
      }
      tableData.value = maintainList.map(item => {
        const [clusterName, zoneName, serverIp] = item.name.split('|');
        item.clusterName = clusterName;
        item.zoneName = zoneName;
        item.serverIp = serverIp;
        return item;
      });
    };
    const computedTableData = computed(() => tableData.value.slice((currentPage.value - 1) * pageSize.value, currentPage.value * pageSize.value));
    const currentPage = ref(1);
    const pageSize = ref(10);
    const itemNumber = computed(() => tableData.value.length);
    const doUnMaintain = async () => {
      if (!tableData.value?.length) {
        ElMessage({
          type: 'error',
          message: 'There is no data that needs to be unmaintained!'
        });
        return;
      }
      const ticketSet = new Set();
      const CommonMaintainList = tableData.value.map(item => {
        const nameArr = item?.name.split('|');
        ticketSet.add(item.ticketnum);
        return {
          memo: 'batch UnMaintain',
          username: userName.value,
          type: item.type,
          status: 0,
          id: item.id,
          ticketnum: item.ticketnum,
          name: nameArr[nameArr.length - 1]
        };
      });
      ElMessageBox.confirm(`Un-maintain item(s) with ticket(s) ${[...ticketSet]}, Do you want to continue?`, 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(async () => {
        await updateMaintain(timeZone.value, CommonMaintainList, true);
        ElMessage({
          type: 'success',
          message: 'Un-maintain completed'
        });
        handleBeforeClose();
      }).catch(() => {
        ElMessage({
          type: 'info',
          message: 'Un-maintain canceled'
        });
      });
    };
    const emits = __emit;
    const dialogVisible = ref(false);
    const handleBeforeClose = () => {
      emits('update:visible', false);
    };
    const handleCancel = () => {
      emits('update:visible', false);
    };
    onMounted(() => {
      dialogVisible.value = visible.value;
    });
    watch(() => visible.value, () => {
      dialogVisible.value = visible.value;
      if (dialogVisible.value) {
        initTable();
      }
    });
    return (_ctx, _cache) => {
      const _component_dialog_header = _resolveComponent("dialog-header");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => dialogVisible.value = $event),
        "show-close": false,
        width: "60%",
        "before-close": handleBeforeClose
      }, {
        header: _withCtx(({
          close
        }) => [_createVNode(_component_dialog_header, {
          onClose: close,
          "header-name": "Batch UnMaintain"
        }, null, 8, ["onClose"])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_table, {
          data: computedTableData.value,
          style: {
            "width": "99%"
          },
          "row-key": "id",
          border: "",
          "default-expand-all": ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            type: "index",
            index: index => index + 1
          }, null, 8, ["index"]), _createVNode(_component_el_table_column, {
            prop: "clusterName",
            label: "Cluster"
          }), _createVNode(_component_el_table_column, {
            prop: "zoneName",
            label: "Zone"
          }), _createVNode(_component_el_table_column, {
            prop: "serverIp",
            label: "Check"
          }), _createVNode(_component_el_table_column, {
            prop: "ticketnum",
            label: "Ticket Number"
          })]),
          _: 1
        }, 8, ["data"]), _createVNode(_component_el_pagination, {
          "current-page": currentPage.value,
          "onUpdate:currentPage": _cache[0] || (_cache[0] = $event => currentPage.value = $event),
          "page-size": pageSize.value,
          "onUpdate:pageSize": _cache[1] || (_cache[1] = $event => pageSize.value = $event),
          "page-sizes": [10, 20, 50],
          layout: "total, sizes, prev, pager, next",
          class: "batch-operation-pagination mt-10",
          total: itemNumber.value
        }, null, 8, ["current-page", "page-size", "total"])]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
          onClick: handleCancel
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("Cancel")])),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: doUnMaintain,
          type: "success"
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("UnMaintain")])),
          _: 1
        })])])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});